import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import OrganizationAPI from '../../api/organization';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getOrganizations($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_ORGANIZATION_FETCHING_STATUS, true);
    try {
      const response = await OrganizationAPI.get();
      commit(types.default.SET_ORGANIZATION_FETCHING_STATUS, false);
      commit(types.default.SET_ORGANIZATIONS, response.data);
    } catch (error) {
      commit(types.default.SET_ORGANIZATION_FETCHING_STATUS, false);
    }
  },
  create: async ({ commit }, organizationInfo) => {
    commit(types.default.SET_ORGANIZATION_CREATING_STATUS, true);
    try {
      const response = await OrganizationAPI.create(organizationInfo);
      commit(types.default.ADD_ORGANIZATION, response.data);
      commit(types.default.SET_ORGANIZATION_CREATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_ORGANIZATION_CREATING_STATUS, false);
      throw error;
    }
  },
  update: async ({ commit }, { id, ...organizationParams }) => {
    commit(types.default.SET_ORGANIZATION_UPDATING_STATUS, true);
    try {
      const response = await OrganizationAPI.update(id, organizationParams);
      commit(types.default.EDIT_ORGANIZATION, response.data);
      commit(types.default.SET_ORGANIZATION_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_ORGANIZATION_UPDATING_STATUS, false);
      throw new Error(error);
    }
  },
  updateSingleAgentPresence: ({ commit }, { id, availabilityStatus }) => {
    commit(types.default.UPDATE_SINGLE_ORGANIZATION_PRESENCE, {
      id,
      availabilityStatus,
    });
  },
  updatePresence: async ({ commit }, data) => {
    commit(types.default.UPDATE_ORGANIZATIONS_PRESENCE, data);
  },
  delete: async ({ commit }, agentId) => {
    commit(types.default.SET_ORGANIZATION_DELETING_STATUS, true);
    try {
      await OrganizationAPI.delete(agentId);
      commit(types.default.DELETE_ORGANIZATION, agentId);
      commit(types.default.SET_ORGANIZATION_DELETING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_ORGANIZATION_DELETING_STATUS, false);
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.default.SET_ORGANIZATION_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_ORGANIZATION_CREATING_STATUS]($state, status) {
    $state.uiFlags.isCreating = status;
  },
  [types.default.SET_ORGANIZATION_UPDATING_STATUS]($state, status) {
    $state.uiFlags.isUpdating = status;
  },
  [types.default.SET_ORGANIZATION_DELETING_STATUS]($state, status) {
    $state.uiFlags.isDeleting = status;
  },

  [types.default.SET_ORGANIZATIONS]: MutationHelpers.set,
  [types.default.ADD_ORGANIZATION]: MutationHelpers.create,
  [types.default.EDIT_ORGANIZATION]: MutationHelpers.update,
  [types.default.DELETE_ORGANIZATION]: MutationHelpers.destroy,
  [types.default.UPDATE_ORGANIZATIONS_PRESENCE]: MutationHelpers.updatePresence,
  [types.default.UPDATE_SINGLE_ORGANIZATION_PRESENCE]: (
    $state,
    { id, availabilityStatus }
  ) =>
    MutationHelpers.updateSingleRecordPresence($state.records, {
      id,
      availabilityStatus,
    }),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
